module.exports = __webpack_public_path__ + "img/linqikeji.6ca60655.png";